import { MessageType } from '../enums/Alert';
import { EventBusEvent } from '../enums/EventBus';
import eventBus from '../event-bus/EventBus';
import type { AlertAction } from '../types/alert';

export const showAlert = (message: string, type: MessageType = MessageType.Error) => {
  const eventData = {
    type,
    isVisible: true,
    children: message,
  };

  eventBus.emit<AlertAction>(EventBusEvent.ToggleAlert, eventData);
};

export const hideAlert = () => {
  eventBus.emit<AlertAction>(EventBusEvent.ToggleAlert, { isVisible: false });
};
